// Вграденото в браузъра влачене на маркиран текст е изключено в модула.
// Клетките на листовете маркират стойността си при фокус, затова лек замах с
// мишката „хваща" числото и го пуска в съседно поле (Количество → Ед. цена):
// стойността изчезва от едното и се долепя в другото. Смислено влачене на текст
// тук няма, затова текстово поле не започва влачене и не приема пускане.
// Влаченето на карти (Взаимозаменяеми) не тръгва от поле и си работи: там
// картата сама разрешава пускането, а тук се отказва само вмъкването на текст.
import type { DragEvent } from "react";

const NON_TEXT_INPUT_TYPES = new Set([
  "button",
  "checkbox",
  "color",
  "file",
  "image",
  "radio",
  "range",
  "reset",
  "submit",
]);

export const isTextField = (target: EventTarget | null): boolean => {
  if (target instanceof HTMLTextAreaElement) return true;
  if (target instanceof HTMLInputElement) return !NON_TEXT_INPUT_TYPES.has(target.type);
  return target instanceof HTMLElement && target.isContentEditable === true;
};

// В capture фазата на корена на модула — хваща и модалите (React събитията
// минават през порталите по React дървото).
export const textDragGuardProps = {
  onDragStartCapture: (event: DragEvent<HTMLElement>) => {
    if (isTextField(event.target)) event.preventDefault();
  },
  onDragOverCapture: (event: DragEvent<HTMLElement>) => {
    if (!isTextField(event.target)) return;
    event.preventDefault();
    event.dataTransfer.dropEffect = "none";
  },
  onDropCapture: (event: DragEvent<HTMLElement>) => {
    if (isTextField(event.target)) event.preventDefault();
  },
};
